export default "__VITE_ASSET__DKoWPZl0__"